import { APP_ID } from "./appConfig";

export default class clientStorage {
  static getAuthToken() {
    return localStorage.getItem(`${APP_ID}_authToken`);
  }

  static setAuthToken(authToken) {
    localStorage.setItem(`${APP_ID}_authToken`, authToken);
  }

  static getProgressBarSize() {
    return localStorage.getItem(`${APP_ID}_progressBarSize`);
  }

  static setProgressBarSize(size) {
    localStorage.setItem(`${APP_ID}_progressBarSize`, size);
  }

  static getConfettiOnComplete() {
    return localStorage.getItem(`${APP_ID}_confettiOnComplete`);
  }

  static setConfettiOnComplete(showOnComplete) {
    localStorage.setItem(`${APP_ID}_confettiOnComplete`, showOnComplete);
  }
}
